// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAFpOGpvaxn3uzMmNi4kVxtUR8baCAlTZU",
    authDomain: "cartago-6b6d1.firebaseapp.com",
    databaseURL: "https://cartago-6b6d1-default-rtdb.firebaseio.com",
    projectId: "cartago-6b6d1",
    storageBucket: "cartago-6b6d1.appspot.com",
    messagingSenderId: "264537022886",
    appId: "1:264537022886:web:e483d5f68325f0c165af67",
    measurementId: "G-73BQ9YXYT9",
  },
  collections: {
    users: "users_dev",
    byotSearchHistory: "byot_search_history_dev",
    plannedActivities: "planned_activities_dev",
    plannedFlights: "planned_flights_dev",
    plannedHotels: "planned_hotels_dev",
    bookedFlights: "booked_flights_dev",
    bookedHotels: "booked_hotels_dev",
    bookedManualActivities: "booked_manual_activities_dev",
    bookedVendorActivities: "booked_vendor_activities_dev",
    trips: "trips_dev",
  },
  stripePublicKey:
    "pk_test_51N8dEZIxdiM71gIjUk0Aak0nO60bDo4Oyflg6NuCJdujb0M6RSoHqGb1zlJJXnw9IJei9HFNc6jlW6vCF9w2BMH400l8DKxYC2",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
